import React, { memo } from 'react';
import GamePanelNew from '../fightCardV2.1.0/GamePanelNew';

import '../../styles/sports/MatchCard.scss';

/**
 *
 * @param {Object} props.match - Match object
 * @param {string} props.match.time - Time of the match
 * @param {string} props.match.day - Day of the match
 * @param {Object} props.match.homeTeam - Home team object
 * @param {string} props.match.homeTeam.name - Home team name
 * @param {Object} props.match.awayTeam - Away team object
 * @param {string} props.match.awayTeam.name - Away team name
 * @param {Object} props.gameData - Game data object
 * @param {Function} props.handleClick - Function to handle click
 * @returns
 */

const MatchCard = memo(({ match, gameData, handleClick, isSelected, teamSelected, onTeamSelect, isFight }) => {
  const { homeTeam, awayTeam } = match;
  const isSpecials = gameData.sport === 'Specials';

  const handleTeamSelect = team => {
    onTeamSelect?.(team);
    handleClick?.(gameData);
  };

  return (
    <div
      className={`match-card ${isSelected ? 'selected' : ''}`}
      onClick={() => handleClick(gameData)}
      role='button'
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && handleClick(gameData)} // accessibility
    >
      {isSpecials ? (
        <GamePanelNew
          sport='Specials'
          leftTeam={homeTeam.name}
          rightTeam={awayTeam.name}
          leftTeamAcronym={homeTeam.name}
          rightTeamAcronym={awayTeam.name}
          leftColor={homeTeam.color}
          rightColor={awayTeam.color}
          selectedTagLabel='You'
          unselectedTagLabel='Opponent'
          startTime={new Date(match.timestamp * 1000)}
          teamSelected={teamSelected}
          onTeamSelect={handleTeamSelect}
          isInteractable={isFight}
        />
      ) : (
        <GamePanelNew
          sport={gameData.league.name}
          leftTeam={homeTeam.name}
          rightTeam={awayTeam.name}
          leftTeamAcronym={homeTeam.name}
          rightTeamAcronym={awayTeam.name}
          leftColor={homeTeam.color}
          rightColor={awayTeam.color}
          selectedTagLabel='You'
          unselectedTagLabel='Opponent'
          startTime={new Date(match.timestamp * 1000)}
          teamSelected={teamSelected}
          onTeamSelect={handleTeamSelect}
          isInteractable={isFight}
        />
      )}
    </div>
  );
});
MatchCard.displayName = 'MatchCard';

export default MatchCard;
